import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

// This component is only a wrapper of the WokButton component and accepts all its props

export default <FunctionalComponentOptions>{
    name: 'WokTab',
    
    functional: true,

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'wok-button', { 
                class: ctx.data.staticClass, 
                attrs: { kind: 'tab', ...ctx.data.attrs },
            }, [
                ctx.slots().default
            ]
        )
    }
}